(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product"]) return;
  try {
    
  (function () {
    function packCount(title) {
      var match = String(title || '').match(/\d+/);
      return match ? parseInt(match[0], 10) : 0;
    }

    function addonVariant(addon, root) {
      var checked = root.querySelector('[data-variant-input]:checked');
      var count = checked ? packCount(checked.dataset.title) : 0;
      var large = count > parseInt(addon.dataset.threshold || '12', 10);
      return {
        id: large ? addon.dataset.largeId : addon.dataset.smallId,
        price: large ? addon.dataset.largePrice : addon.dataset.smallPrice
      };
    }

    // Keep the add-on price in step with the chosen pack size.
    document.addEventListener('change', function (event) {
      if (!event.target.matches || !event.target.matches('[data-variant-input]')) return;
      var root = event.target.closest('[data-product]');
      var addon = root && root.querySelector('[data-addon]');
      if (!addon) return;
      var priceEl = addon.querySelector('[data-addon-price]');
      if (priceEl) priceEl.textContent = addonVariant(addon, root).price;
    });

    // When the box is ticked, add the magnets and the add-on together.
    document.addEventListener('submit', function (event) {
      var form = event.target;
      if (!form.classList || !form.classList.contains('product-form')) return;
      var root = form.closest('[data-product]');
      var addon = root && root.querySelector('[data-addon]');
      var check = addon && addon.querySelector('[data-addon-check]');
      if (!check || !check.checked) return;

      event.preventDefault();
      var data = new FormData(form);
      var properties = {};
      data.forEach(function (value, key) {
        var m = key.match(/^properties\[(.+)\]$/);
        if (m && value !== '') properties[m[1]] = value;
      });
      var choice = addonVariant(addon, root);
      var items = [
        { id: Number(data.get('id')), quantity: 1, properties: properties },
        { id: Number(choice.id), quantity: 1, properties: { 'For': addon.dataset.for } }
      ];

      var button = root.querySelector('[data-add-button]');
      var error = addon.querySelector('[data-addon-error]');
      if (button) button.disabled = true;
      if (error) error.hidden = true;

      var base = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      fetch(base + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function (response) {
          return response.json().then(function (body) {
            if (!response.ok) throw new Error(body.description || body.message || 'Could not add to cart');
            window.location.href = base + 'cart';
          });
        })
        .catch(function (err) {
          if (button) button.disabled = false;
          if (error) {
            error.textContent = err.message + '. Please try again.';
            error.hidden = false;
          }
        });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
